// The moment this device pressed Print, on this device's own clock.
//
// The `Printed:` line on a receipt cannot be produced server-side. The
// backend's every clock is UTC (`datetime.utcnow`) and no tenant timezone is
// stored anywhere to convert it with, so a stamp it invented would be wrong
// for most tenants most of the year. That is not hypothetical: it shipped.
// On 2026-09-08 a staging receipt carried
//
//     Date: 2026-09-08 Time: 23:07:36     <- transaction.time, written local
//     Printed: 2026-09-08 22:07:42        <- created_at, UTC
//
// — two times an hour apart for one sale. The backend now stamps ONLY what a
// caller hands it (app/services/receipt_renderer.py), and this is the caller.
//
// Deliberately date-fns `format`, exactly as transactionFlow.buildTransaction
// produces the transaction's own `date`/`time` fields. Same library, same
// local getters, one instant — so the header and the footer of a receipt
// cannot drift apart again.
//
// NEVER reach for `toISOString()`, `toUTCString()` or any `getUTC*` here.
// They are UTC by definition and would silently reintroduce the exact bug
// above; `printedAtStamp.test.js` pins that across three real timezones.
import { format } from 'date-fns';

// The shape the backend accepts (`printing._local_print_stamp`) and the
// renderer prints. Anything else is dropped server-side and the line vanishes
// from the receipt, so this format is a contract, not a preference.
const STAMP_FORMAT = 'yyyy-MM-dd HH:mm:ss';

/**
 * @param {Date} [at] the moment to stamp; defaults to now. Injectable so the
 *   tests can fix an instant — production callers pass nothing.
 * @returns {string} e.g. "2026-09-08 23:07:42", in this device's local time.
 */
export const printedAtStamp = (at = new Date()) => format(at, STAMP_FORMAT);

export default printedAtStamp;
